import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { people } from "../../config/imagesLink";
import MessageInteraction from "./MessageInteraction";
import PushPinSharpIcon from "@mui/icons-material/PushPinSharp";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getChatUnreadCount } from "../../utils/chatReadUtils";
import { formatMessagePreviewText } from "../../utils/messageReplyUtils";

const MessageList = ({
  isShown,
  getChatList,
  archiveMessage,
  item,
  index,
  active,
  setActive,
  UserId,
  setMsgId,
  getArchivedList,
  getMessageList,
  setIsShown,
  setChatList,
}) => {
  const { t } = useTranslation();

  const getDisplayDate = (date) => {
    const today = moment().startOf("day");
    const msgDate = moment(date).startOf("day");

    if (msgDate.isSame(today, "day")) {
      return t("Notifications.Today");
    }
    if (msgDate.isSame(today.clone().subtract(1, "day"), "day")) {
      return t("Notifications.Yesterday");
    }
    if (msgDate.isAfter(today.clone().subtract(6, "day"))) {
      return msgDate.format("dddd");
    }
    return msgDate.format("DD-MM-YYYY");
  };

  const getUserImage = (image) =>
    !image || image === "" ? people.DefaultProfile : image;

  const handleImageError = (e) => {
    e.target.src = people.DefaultProfile;
  };

  const isBlockedByYou =
    item.chatInfo?.isBlockedByYou === true || item.isBlockedByYou === true;

  const unreadCount = getChatUnreadCount(item);
  const isCurrentChat =
    UserId &&
    UserId !== "All" &&
    String(item.chatInfo?.toUserUid) === String(UserId);
  const isActive = isCurrentChat || active === index;
  const showUnreadBadge = unreadCount > 0 && !isCurrentChat;
  const unreadBadgeLabel = unreadCount > 99 ? "99+" : unreadCount;

  const previewText = isBlockedByYou
    ? `${t("Newsfeed.Want to continue chat with this user")} ${t("Newsfeed.Unblock from settings")}`
    : `${item?.isOwned ? `${t("Notifications.You")}: ` : ""}${formatMessagePreviewText(item.lastMsg || "")}`;

  return (
    <Link
      to={`/Message/${item?.chatInfo?.toUserUid}`}
      className="message-list-link"
      onClick={() => {
        setActive(index);
        setMsgId(item.chatInfo.msgID);
        setIsShown(false);
      }}
    >
      <div
        className={`${isShown ? "d-block" : "d-md-block d-none"} message-list-item`}
      >
        <div
          className={`${isActive ? "activeMsg" : ""} message-cards d-flex align-items-center`}
        >
          <div className="msg-list-avatar-wrap me-3 ms-1">
            <img
              src={getUserImage(item.chatInfo?.toUserImage)}
              onError={handleImageError}
              alt={item.chatInfo?.toUserFullName || ""}
            />
            {item.chatInfo?.toUserIsOnline === true ? (
              <span className="msg-list-online-dot" aria-hidden="true" />
            ) : null}
          </div>

          <div className="msg-content flex-grow-1 me-1">
            <div className="name-time d-flex justify-content-between align-items-center gap-2">
              <div className="message-user-name darkmode f-12 f-600">
                {item.chatInfo?.toUserFullName}
              </div>
              <div
                className={`message-time darkmode f-10 f-400 flex-shrink-0 ${
                  showUnreadBadge ? "message-time-unread" : ""
                }`}
              >
                <Tooltip
                  title={
                    <p className="text-light mb-0">
                      {moment
                        .utc(item.lastMsgTime)
                        .local()
                        .format("DD MMMM YYYY")}
                    </p>
                  }
                  arrow
                >
                  <span>{getDisplayDate(item.lastMsgTime)}</span>
                </Tooltip>
              </div>
            </div>

            <div className="msg-preview-row">
              <div
                className={`msg-preview-text ${
                  item.lastMsgIsRead === false && !isCurrentChat
                    ? "fw-bolder"
                    : ""
                }`}
              >
                <p className="messageText darkmode f-10">{previewText}</p>
              </div>

              <div className="msg-preview-meta">
                {showUnreadBadge ? (
                  <span
                    className={`msg-unread-badge ${
                      unreadCount > 9 ? "msg-unread-badge-wide" : ""
                    }`}
                  >
                    {unreadBadgeLabel}
                  </span>
                ) : null}
                {item.isPined === true ? (
                  <PushPinSharpIcon className="material-symbols-sharp msg-pin-icon" />
                ) : null}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <MessageInteraction
                    chatId={item.chatID}
                    isRead={item.lastMsgIsRead}
                    isPined={item.isPined}
                    getChatList={getChatList}
                    archiveMessage={archiveMessage}
                    usermsgId={item.chatInfo.msgID}
                    UserId={item.chatInfo.toUserUid}
                    getArchivedList={getArchivedList}
                    getMessageList={getMessageList}
                    toUserUId={item.chatInfo.toUserUid}
                    setChatList={setChatList}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default MessageList;
